<template lang="pug">
v-navigation-drawer(
  fixed
  clipped
  v-model="showSearchPanel"
  app
  floating
  width="500"
  right
  temporary
  touchless
)
  v-btn(icon @click.native="showSearchPanel = false").closeButton
      v-icon close
  ais-instant-search(
    :search-client="searchClient"
    :index-name="indexName"
  ).pt-2.pl-2.pr-2
    ais-search-box
      div(slot-scope="{ currentRefinement, isSearchStalled, refine }")
        v-text-field(
          label="Search"
          type="search"
          v-model="searchText"
          maxlength="255"
          @input="refine(searchText)"
        )
  v-tabs(fixed-tabs v-model="active")
    v-tab() Content
    v-tab() Quicklinks
    v-tab-item()
      ais-instant-search(
        :search-client="searchClient"
        :index-name="indexName"
      ).pt-2.pl-2.pr-2
        ais-configure(
          :query="searchText"
          :hitsPerPage="5"
          :attributesToSnippet="['content:30']"
          :filters="moduleFilter"
        )
        ais-hits(:transform-items="transformContent")
          v-container(fluid grid-list-lg slot-scope="{ items }")
            v-layout(row wrap)
              v-flex(v-for="item in items"
                :key="item.objectID" )
                v-card(
                  flat
                  :key="item.objectID"
                  ripple
                  hover
                  @click="showPage(item.moduleId, item.pagePath)")
                  v-card-text()
                    div(class="customSnippet")
                      span(v-show="!item.displayName") {{ item.moduleName }}
                      span(v-show="item.displayName") {{ item.displayName }}
                    ais-highlight(
                      attribute="title"
                      :hit="item"
                      :class-names="highlightClassNames"
                    )
                    span()  --
                    ais-snippet(
                      attribute="transformedcontent"
                      :hit="item"
                      highlighted-tag-name="em"
                      :class-names="snippetClassNames"
                    )
              v-divider
        ais-pagination
    v-tab-item()
      ais-instant-search(
        :search-client="searchClient"
        :index-name="qlIndexName"
      ).pt-2.pl-2.pr-2
        ais-configure(
          :query="searchText"
          :filters="quicklinksFilter"
        )
        ais-hits
          v-container(fluid grid-list-sm slot-scope="{ items }")
            v-layout(row wrap)
              v-flex(v-for="item in items"
                :key="item.objectID" shrink)
                v-card(
                  width="120px"
                  height="140px"
                  :key="item.objectID"
                  ripple
                  hover
                  @click="getLink(item)").qlcard
                  img(
                    width="120px"
                    :src="remapColors(item.icon)"
                    ).iconPadding
                  v-card-text( width="90px").linksTitle
                    ais-highlight(
                      attribute="title"
                      :hit="item"
                      :class-names="qlHighlightClassNames"
                    )
        ais-pagination
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';
import Base from '@/components/views/Base';
import * as types from '@/store/mutationTypes';
import { blobs } from '@/api';

export default {
    name: 'AlgoliaSidePanelSearch',

    extends: Base,

    data() {
        return {
            active: null,
            cardDefaultWidth: '120px',
            openFileType: ['.pdf', '.gif', '.jp2', '.jpe', '.jpeg', '.jpg', '.png', '.bmp'],
            searchClient: algoliasearch(
                process.env.ALGOLIA_APPLICATION_ID,
                process.env.ALGOLIA_SEARCH_KEY
            ),
            snippetClassNames: {
                'ais-Snippet': 'customSnippet',
                'ais-Snippet-highlighted': 'customSnippetHighlighted'
            },
            highlightClassNames: {
                'ais-Highlight': 'customHighlight',
                'ais-Highlight-highlighted': 'customHighlightHighlighted',
            },
            qlHighlightClassNames: {
                'ais-Highlight': 'linksTitle',
                'ais-Highlight-highlighted': 'linksTitle',
            }
        };
    },

    computed: {
        ...mapState({
            subdomain: state => state.session.subdomain,
            client: state => state.client
        }),

        ...mapGetters({
            activatedCEModules: 'activatedCEModules/items',
            contextItemValues: 'clientContext/values',
            contextItems: 'clientContext/items',
        }),

        showSearchPanel: {
            get() {
                return this.$store.state.appearance.showSearchPanel;
            },

            set(value) {
                this.$store.commit(types.APPEARANCE_SET_SEARCH_PANEL, value);
            }
        },

        searchText: {
            get() {
                // const searchBoxDiv = this.$refs.searchBoxDiv;
                // if (searchBoxDiv) {
                //     console.log(searchBoxDiv);
                // }
                return this.$store.state.app.searchText;
            },

            set(value) {
                this.$store.commit(types.APP_SET_SEARCH_TEXT, value);
            }
        },

        indexName() {
            return process.env.ALGOLIA_INDEX_NAME;
        },

        qlIndexName() {
            return process.env.ALGOLIA_QL_INDEX_NAME;
        },

        moduleFilter() {
            const fModules = this.activatedCEModules.reduce((filter, module) => {
                if (filter.length === 0) {
                    return `moduleId:${module.id}`;
                }
                return `${filter} OR moduleId:${module.id}`;
            }, '');
            return fModules;
        },

        quicklinksFilter() {
            // const siteUri = `${this.subdomain}.complispaceprimary.com.au`;

            if (this.client && this.client.subdomain) {
                const thisClient = `siteUri:'${this.client.subdomain}'`;
                return this.client.parentId && this.client.parent.subdomain ?
                    `${thisClient} OR siteUri:'${this.client.parent.subdomain}'` :
                    thisClient;
            }
            return `siteUri: '${this.subdomain}'`;
        }
    },

    methods: {

        // Replace context keys with their value
        replaceContextKey(content) {
            let replacedContent = content;
            let contextKeyStr;
            try {
                this.contextItems.forEach((contextKey) => {
                    contextKeyStr = contextKey.key;
                    if (contextKeyStr) {
                        const regexSpecialChar = '[&\\/\\\\#,+()$~%.\'":*?<>{}]';
                        const regexPatternSpecial = new RegExp(regexSpecialChar, 'g');

                        contextKeyStr = contextKeyStr.replace(regexPatternSpecial, '');

                        const regexContextKey = `(\\{{${contextKeyStr}}})`;
                        const regexPatternKey = new RegExp(regexContextKey, 'ig');

                        if (contextKey.value) {
                            replacedContent =
                                replacedContent.replace(regexPatternKey, contextKey.value);
                        } else if (contextKey.placeholder) {
                            replacedContent =
                            replacedContent.replace(regexPatternKey, contextKey.placeholder);
                        } else {
                            replacedContent = replacedContent.replace(regexPatternKey, `Missing value for {{${contextKey.key}}}`);
                        }
                    }
                });
            } catch (e) {
                console.log(e);
                // Try rendering
                return e;
            }

            return replacedContent;
        },

        // Transform module content by replacing context key with their actual value or placeholder.
        transformContent(items) {
            return items.map((item) => {
                const transformedItem = item;
                transformedItem._snippetResult.transformedcontent =
                        { value: this.replaceContextKey(item._snippetResult.content.value), };
                return transformedItem;
            });
        },

        showPage(moduleId, pagePath) {
            // Forcing a close on seach navigation drawer is required to
            // close it the drawer if the user clicks on the search result
            // and the current page are the same.
            this.showSearchPanel = false;

            this.$router.push({
                name: 'Page',
                params: { moduleId, pagePath }
            });
        },

        showLink(url) {
            window.open(url, '_blank');
        },

        showFile(blob, fileName) {
            // Source: https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
                return;
            }
            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(blob);
            const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
            if (this.openFileType.indexOf(fileExtension) !== -1) {
                const win = window.open('', '_blank');
                win.location.href = data; // eslint-disable-line no-param-reassign
            } else {
                const link = document.createElement('a');
                link.href = data;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(data);
                }, 100);
            }
        },

        getLink(link) {
            const stripPort = process.env.QUICK_LINKS_API_URL.replace(/:\d{1,4}/, '');
            if (link.url.includes(stripPort)) {
                this.setLoading(true);
                let id = link.url.split('/');
                id = id[id.length - 1];
                blobs.getLinks(id, this.subdomain).then((result) => {
                    try {
                        // FIXME: Workaround for our server not sending
                        // Content-Disposition. Load balancer issue?
                        const contentType = result.headers['content-type'];
                        let fileName = result.headers['content-disposition'];
                        fileName = fileName.substring(fileName.indexOf('=') + 1);
                        fileName = fileName.substring(1, fileName.length - 1);
                        const blob = new Blob([result.data],
                            { type: contentType });
                        this.showFile(blob, fileName);
                    } catch (err) {
                        console.log(err);
                    } finally {
                        this.setLoading(false);
                    }
                });
            } else {
                window.open(link.url, '_blank');
            }
        },
    }
};
</script>

<style scoped>
.customHighlight {
  font-size: 16px;
  color: rgba(0,0,0,0.74);
  font-style: normal;
}
.customHighlightHighlighted {
  font-size: 16px;
  font-style: normal;
  background-color: rgba(0, 0, 0, 0);
  background-image: none;
  background-origin: padding-box;
  border-bottom-color: rgb(84, 104, 255);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-image-outset: 0px;
  border-image-repeat: stretch;
  border-image-slice: 100%;
  border-image-source: none;
  border-image-width: 1;
  border-left-color: rgb(84, 104, 255);
  border-left-style: solid;
  border-left-width: 0px;
  border-right-color: rgb(84, 104, 255);
  border-right-style: solid;
  border-right-width: 0px;
  border-top-color: rgb(84, 104, 255);
  border-top-style: solid;
  border-top-width: 0px;
  box-sizing: border-box;
  color: rgba(33, 36, 61, 0.5);
}
.v-card {
  overflow: hidden;
}

.customSnippet {
  font-size: 14px;
  color: rgba(0,0,0,0.54);
}
.customSnippetHighlighted {
  font-size: 14px;
  font-style: normal;
  background-color: rgba(0, 0, 0, 0);
  background-image: none;
  background-origin: padding-box;
  border-bottom-color: rgb(84, 104, 255);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-image-outset: 0px;
  border-image-repeat: stretch;
  border-image-slice: 100%;
  border-image-source: none;
  border-image-width: 1;
  border-left-color: rgb(84, 104, 255);
  border-left-style: solid;
  border-left-width: 0px;
  border-right-color: rgb(84, 104, 255);
  border-right-style: solid;
  border-right-width: 0px;
  border-top-color: rgb(84, 104, 255);
  border-top-style: solid;
  border-top-width: 0px;
  box-sizing: border-box;
  color: rgba(33, 36, 61, 0.5);
}
.top {
  position: fixed;
  top: 20px;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 23px;
}
.middle {
  min-height: calc(100vh - 70px);
  overflow: scroll;
}
.bottom {
  position: fixed;
  bottom: 30px;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 23px;
}
.closeButton {
  float: right;
}

@media (max-width:768px){
  .v-navigation-drawer--absolute {
    position: fixed;
  }
}
.qlcard {
    max-width: 120px;
}

.iconPadding {
  padding: 7%;
  text-align: center;
  margin: 0 auto;
  max-width: 180px;
  min-width: 80px;
}
.linksTitle {
    color:#696969;
    font-weight:bold;
    height:28px;
    padding: 5px 0;
    text-align: center;
    line-height: 14px;
    font-size: 12px;
}
.linksTitle ::selection {
    background-color: transparent !important;
    color: #696969 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/content/AlgoliaSidePanelSearch.vue